import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ReferenceLine,
  ResponsiveContainer
} from "recharts";
import type { Ear } from "../../../type/tonalTest";

const COLORS: Record<Ear, string> = {
  left: "#1a56db",
  right: "#e02424"
};

export default function TonalResultChart({
  data,
  label,
  ear
}: {
  data: number[];
  label: string;
  ear: Ear;
}) {
  const frequencies = [125, 250, 500, 1000, 2000, 4000, 8000];

  const chartData = frequencies.map((f, i) => ({
    freq: f,
    value: data[i] ?? null
  }));

  const color = COLORS[ear];

  return (
    <div className="chart">
      <div className="d-flex align-items-center gap-2 mb-3">
        <span className="result-chart__dot" style={{ backgroundColor: color }}></span>
      </div>

      <div className="result-chart__frame">
        <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={chartData}
          style={{ backgroundColor: "transparent" }}
          margin={{ top: 0, right: 8, left: 0, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="rgb(164, 175, 196)" />

          <XAxis
            dataKey="freq"
            tickFormatter={(v) => `${v} Hz`}
            tick={{ fontSize: 12, fill: "#262727" }}
            stroke="rgba(186, 198, 220, 0.4)"
          />

          <YAxis
            reversed
            domain={[-10, 120]}
            tickCount={14}
            interval={0}
            tickFormatter={(v) => `${v}`}
            label={{
              value: "dB HL",
              angle: -90,
              position: "insideLeft",
              offset: 25,
              style: { fontSize: 12, fill: "#262727" }
            }}
            tick={{ fontSize: 12, fill: "#262727" }}
            stroke="rgba(186, 198, 220, 0.4)"
            padding={{ top: 10, bottom: 10 }}
          />

          <Tooltip
            formatter={(value) => [`${value} dB HL`, label]}
            labelFormatter={(v) => `${v} Hz`}
            contentStyle={{
              backgroundColor: "#c6d6f4",
              border: "1px solid rgba(244, 197, 108, 0.24)",
              borderRadius: "12px",
              color: "#fdfdfd"
            }}
          />

          <Legend
            verticalAlign="top"
            formatter={() => label}
            wrapperStyle={{ paddingBottom: 10, color: "#262727" }}
          />

          <ReferenceLine
            y={20}
            stroke="#f28b82"
            strokeDasharray="6 4"
            strokeOpacity={0.75}
            label={{
              value: "Granica normy (20 dB)",
              position: "insideTopRight",
              fontSize: 11,
              fill: "#f8b4b4",
              opacity: 0.9
            }}
          />

          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={2.5}
            dot={{ r: 5, fill: color, strokeWidth: 0 }}
            activeDot={{ r: 7 }}
            name={label}
            isAnimationActive={false}
          />
        </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}